var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5H212.5V212.5H12.5V12.5Z",
    fill: "#F5DE19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.056 149.219C131.547 152.247 133.864 154.793 136.739 156.562C139.614 158.332 142.931 159.253 146.306 159.219C153.119 159.219 157.475 155.812 157.475 151.094C157.475 145.469 153 143.456 145.5 140.175L141.387 138.413C129.512 133.356 121.637 127.025 121.637 113.638C121.637 101.306 131.013 91.9125 145.719 91.9125C150.479 91.5687 155.236 92.6342 159.395 94.976C163.554 97.3179 166.932 100.832 169.106 105.081L156.25 113.3C155.413 111.193 153.955 109.391 152.069 108.132C150.184 106.873 147.961 106.216 145.694 106.25C144.705 106.151 143.706 106.259 142.761 106.567C141.816 106.876 140.946 107.377 140.206 108.041C139.465 108.704 138.871 109.514 138.461 110.42C138.052 111.325 137.835 112.306 137.825 113.3C137.825 118.231 140.881 120.231 147.938 123.3L152.05 125.063C166.025 131.056 173.925 137.162 173.925 150.894C173.925 165.7 162.294 173.812 146.675 173.812C140.589 174.2 134.522 172.819 129.204 169.834C123.886 166.85 119.546 162.39 116.706 156.994L130.056 149.219ZM71.9625 150.644C74.5437 155.225 76.8937 159.1 82.5437 159.1C87.9437 159.1 91.3562 156.988 91.3562 148.769V92.85H107.8V148.987C107.8 166.012 97.8 173.763 83.2437 173.763C78.0984 174.044 72.9885 172.761 68.5855 170.084C64.1826 167.407 60.6928 163.46 58.575 158.763L71.9625 150.644Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/JS.f13742142805fbe981e80b927631823f.svg";
export { ForwardRef as ReactComponent };